module.exports = __webpack_public_path__ + "static/media/growing_new_farmers_desktop.7862f955.jpg";